<confirmaciongenerica #appconfirmacion (ConfirmoUsuario)="ConfirmoUsuario($event)" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></confirmaciongenerica>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">Configuración comercialización</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>
    <div class="d-flex justify-content-between flex-wrap filtrosTable align-items-center" autocomplete="off">
        <div [formGroup]="form" class="d-flex flex-wrap" autocomplete="off">
            <div class="p-1">
                <h2>Configuración comercialización</h2>
            </div>
            <div class="p-1">
                <mat-form-field appearance="fill">
                    <mat-label>Filtrar datos</mat-label>
                    <input matInput formControlName="filtro" autocomplete="off" (ngModelChange)="FiltrarRegistros()">
                    <button mat-icon-button matSuffix type="button">
                        <mat-icon>search</mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </div>
        <div>
            <a (click)="registrarNuevo()" mat-icon-button matSuffix type="button" class="accesoAdd">
                <mat-icon>add</mat-icon>
            </a>
        </div>
    </div>
    <div class="mat-elevation-z8 p-0">
        <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" matSort class="table table-striped table-hover">

                <!-- id Column -->
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
                    <td mat-cell *matCellDef="let row"> {{row.id}} </td>
                </ng-container>
                <!-- codigo Column -->
                <ng-container matColumnDef="codigo">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Código </th>
                    <td mat-cell *matCellDef="let row"> {{row.codigo}} </td>
                </ng-container>
                <!-- descripcion Column -->
                <ng-container matColumnDef="descripcion">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Descripción </th>
                    <td mat-cell *matCellDef="let row"> {{row.descripcion}} </td>
                </ng-container>
                <!-- activo Column -->
                <ng-container matColumnDef="activo">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Activo </th>
                    <td mat-cell *matCellDef="let row"> {{row.activo ? 'SI' : 'NO'}} </td>
                </ng-container>
                <!-- acciones Column -->
                <ng-container matColumnDef="acciones">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Acciones </th>
                    <td mat-cell *matCellDef="let row">
                        <a type="button" class="icnTable" (click)="abrirDetalle(row)">
                            <mat-icon>edit</mat-icon>
                        </a>
                        <a type="button" class="icnTable" (click)="eliminar(row)">
                            <mat-icon>delete</mat-icon>
                        </a>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnasEncabezado"></tr>
                <tr mat-row *matRowDef="let row; columns: columnasEncabezado;"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                </tr>
            </table>
        </div>
    </div>
    <div class="fondopaginador">
        <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
    </div>
</div>